import CouponEventDetailsContainer from './CouponEventDetailsContainer';
export default CouponEventDetailsContainer;
